<template>
  <div class="row m-0 abs_page">
    <div class="col-11 p-0">
      <div class="row m-0">
        <site-header></site-header>
        <div class="col-12 site_padding">
          <div class="entry-header">
            <div class="page-title" v-html="title"></div>
          </div>
          <div class="row m-0">
            <div class="col-12 mt-n5 abs">
              <div class="row m-0 align-items-center justify-content-center">
                <div class="col-7 col-sm-5 col-md-4 col-lg-5 col-xl-4 text-center">
                  <img :src="this.featuredImage" class="img-fluid " alt="" loading="lazy">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-11 site_padding">
          <div class="entry-content infoPage" v-html="content">
          </div>
          <!-- <div class="entry-content">
            <div class="col-12 p-0" >
              <h2>Collaborating institutions</h2>
            </div>
            <div class="col-12 p-0">
              <div class="row m-0">
                <div class="col-5 col-lg-2 mb-3 pl-0 pr-4" v-for="(img, key) in collab_imgs" :key="key">
                  <img :src="img" class="img-fluid max_height">
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="entry-content">
            <div class="col-12 p-0" >
              <h2>FUNDERS AND SPONSORS</h2>
            </div>
            <div class="col-12 p-0">
              <div class="row m-0">
                <div class="col-5 col-lg-2 mb-3 pl-0 pr-4" v-for="(img, key) in funder_imgs" :key="key">
                  <img :src="img" class="img-fluid max_height">
                </div>
              </div>
            </div>
          </div> -->
        </div>
        <site-footer></site-footer>
      </div>
    </div>
  </div>
</template>
<script>
import { getPage } from '@/api/wp.js'
export default {
  name: 'Info',
  props: ['pageId'],
  components: {
    'site-header': () => import('../components/Header.vue'),
    'site-footer': () => import('../components/Footer.vue')
  },
  data () {
    return {
      content: '',
      title: '',
      featuredImage: '',
      collab_imgs: [],
      funder_imgs: []
    }
  },
  async created () {
    if (this.pageId) {
      const resp = await getPage(this.pageId)
      this.content = resp.data.content.rendered
      this.title = resp.data.title.rendered
      this.collab_imgs = resp.data.collab_images
      this.funder_imgs = resp.data.funder_images
      if (resp.data.featured_media) {
        this.featuredImage = resp.data.featured_image_src
      }
    }
  }
}
</script>

<style scoped>
.active .entry-header {
  position: relative;
  z-index: 2;
}
.active .abs {
  position: relative;
  z-index: 1;
}
.wp-block-columns .wp-block-column h2 {
  margin-top: 3.666rem;
}
.max_height {
  max-height: 5vh;
}
@media (min-width: 768px) {
  .entry-header {
    margin-top: -1rem;
  }
}
</style>